import React from 'react';
import LargePopup from 'components/popup/large-popup';
import styled from 'styled-components';
import { COLOR } from 'constants/colors';
import { CommonStyledComponentProps } from '__utils/type';
import { useMediaQuery } from 'react-responsive';


interface mandateTypeProps {
    mandateType?: string;
    onClose: Function;
    children: any;
}

const PopupOuterCont = styled.div<CommonStyledComponentProps>`
    background-color: ${COLOR.GREY_BG};
    position: ${(props: CommonStyledComponentProps) => props.isMobile ? 'fixed' : ''};
    width: 100%;
    height: ${(props: CommonStyledComponentProps) => props.isMobile ? `calc(100vh - 58px)` : ``};  
`;

const PopupContDiv = styled.div<CommonStyledComponentProps>`
    overflow: hidden;
    background-color: ${COLOR.WHITE};
    border-radius: 5px;
    margin: ${(props: CommonStyledComponentProps) => props.isMobile ? "16px" : "0px"};
    text-align: center;
    height: ${(props: CommonStyledComponentProps) => props.isMobile ? `` : ``};  

    .centeredText{
        margin: ${(props: CommonStyledComponentProps) => props.isMobile ? `24px 30px 0` : `40px 53px 40px`};  
    }

    .centeredText img{
        margin-bottom: 24px;
    }
    .successText{
        margin-top: 15px;
        font-size: 16px;
    }
   
`;

const MandateSuccessPopup: React.FC<mandateTypeProps> = ({ mandateType,onClose,...props }: mandateTypeProps) => {
    const isMobile = useMediaQuery({ maxWidth: 767 });

    return <LargePopup
        closable={false}
        modalWidth='376px'
        headerContent={
            <div>
                <i className="icon-Back headerIconSet" style={{ fontSize: "22px", marginRight: "10px", lineHeight: "1.5" }}
                    onClick={ () => onClose() }>
                </i>
            </div>}
    >
        <PopupOuterCont isMobile={isMobile}>
            <PopupContDiv isMobile={isMobile}>
                <div className='centeredText'>
                  {props.children}
                </div>
            </PopupContDiv>
        </PopupOuterCont>
    </LargePopup>
}

export default MandateSuccessPopup;
